import { render, staticRenderFns } from "./AboutOutbreak.vue?vue&type=template&id=5792ffae"
import script from "./AboutOutbreak.vue?vue&type=script&lang=js"
export * from "./AboutOutbreak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports